import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DaButtonModule } from '../da-button';
import { DpDatePickerModule } from 'ng2-date-picker';
import { AutosizeModule } from 'ngx-autosize';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DateComponent } from './components/date/date.component';
import { InputComponent } from './components/input/input.component';
import { LegalConsentComponent } from './components/legal-consent/legal-consent.component';
import { NumberComponent } from './components/number/number.component';
import { PhoneComponent } from './components/phone/phone.component';
import { RadiobuttonComponent } from './components/radiobutton/radiobutton.component';
import { SelectComponent } from './components/select/select.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { DynamicFieldDirective } from './shared/directives/dynamic-field.directive';
import { GetIterableErrorsPipe } from './shared/pipes/get-iterable-errors.pipe';
import { FormBuilderService } from './shared/services/form-builder.service';
import { FormUtilsService } from './shared/services/form-utils.service';
import { HubspotOperators } from './shared/services/hubspot/hubspot-operators';
import { FormsService } from './shared/services/forms.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        DynamicFieldDirective,
        InputComponent,
        SelectComponent,
        DateComponent,
        RadiobuttonComponent,
        CheckboxComponent,
        TextareaComponent,
        GetIterableErrorsPipe,
        NumberComponent,
        LegalConsentComponent,
        PhoneComponent

    ],
    exports: [
        DynamicFieldDirective,
        InputComponent,
        SelectComponent,
        DateComponent,
        RadiobuttonComponent,
        CheckboxComponent,
        TextareaComponent,
        GetIterableErrorsPipe,
        NumberComponent,
        LegalConsentComponent,
        PhoneComponent

    ],
    providers: [FormsService, FormBuilderService, FormUtilsService, HubspotOperators, DynamicFieldDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        DpDatePickerModule,
        DaButtonModule,
        AutosizeModule,
        TranslateModule.forChild()
    ]
})
export class FormBuilderModule {}
